import React from 'react';

import { TextGallery } from '@/app/_components/TextGallery';
import { TextGalleryProps } from './types';

import classes from './index.module.scss';

export const TextGalleryGraphQL: React.FC<TextGalleryProps> = props => {
  const { id } = props;

  return (
    <div id={`block-${id}`} className={classes.blockWrapper}>
      <TextGallery textGallery={props} />
    </div>
  );
};

export default TextGalleryGraphQL;
